(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("CampaignInsightsModalFactory", CampaignInsightsModalFactory);


    /** @ngInject */
    function CampaignInsightsModalFactory($uibModal) {

        var factory = {
            connect: connect
        };

        return factory;

        function connect(campaignId) {
            return $uibModal.open({
                templateUrl: 'app/integrations/facebook-business/campaign-insights-modal/campaign-insights.modal.html',
                controller: 'CampaignInsightsModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    data: function() {
                        return campaignId;
                    }
                }
            }).result;
        }
    }

})();
